export enum TransactionViewHistoryTabs {
    Overview,
    DocsDownloaded,
    Contacts,
}
